(function () {
  if (window.themePubsub) {
    return;
  }

  const subscribers = new Map();

  window.themePubsub = {
    subscribe(event, callback) {
      if (typeof callback !== 'function') {
        return function noop() {};
      }
      if (!subscribers.has(event)) {
        subscribers.set(event, new Set());
      }
      const set = subscribers.get(event);
      set.add(callback);
      return function unsubscribe() {
        set.delete(callback);
        if (set.size === 0) {
          subscribers.delete(event);
        }
      };
    },
    publish(event, data) {
      const set = subscribers.get(event);
      if (!set) {
        return;
      }
      set.forEach(function (callback) {
        try {
          callback(data);
        } catch (error) {
          console.error('[themePubsub] subscriber error for "' + event + '":', error);
        }
      });
    }
  };
})();
